import { useCallback } from 'react';

export const useCsvExport = () => {
  const exportCsv = useCallback(
    (
      data: any[],
      headers: string[],
      filename: string,
      mapRow: (item: any) => (string | number | boolean | null | undefined)[],
    ) => {
      if (!data || !data.length) return;

      const csvContent = [
        headers.join(';'),
        ...data.map((item) => mapRow(item).join(';')),
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    [],
  );

  return { exportCsv };
};
